export const REACT_SELECT_CLASS_PREFIX = "react-select";

export function getReactSelectStyles() {
  return {
    control: (base, state) => ({
      ...base,
      backgroundColor: "var(--input-bg)",
      borderColor: state.isFocused ? "var(--archeo-color)" : "var(--border-color)",
      boxShadow: state.isFocused ? "0 0 0 1px var(--archeo-color)" : "none",
      minHeight: "48px",
      "&:hover": {
        borderColor: "var(--archeo-color)",
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "var(--card-bg)",
      border: "1px solid var(--border-color)",
      zIndex: 20,
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: "var(--card-bg)",
      paddingTop: 0,
      paddingBottom: 0,
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "var(--archeo-color)"
        : state.isFocused
          ? "var(--surface-bg)"
          : "var(--card-bg)",
      color: state.isSelected ? "#fff" : "var(--text-color)",
      cursor: "pointer",
    }),
    singleValue: (base) => ({
      ...base,
      color: "var(--text-color)",
    }),
    input: (base) => ({
      ...base,
      color: "var(--text-color)",
    }),
    placeholder: (base) => ({
      ...base,
      color: "var(--text-muted)",
    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "var(--surface-bg)",
    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "var(--text-color)",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "var(--archeo-color)",
    }),
    clearIndicator: (base) => ({
      ...base,
      color: "var(--text-muted)",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: "var(--border-color)",
    }),
  };
}

export function getReactSelectThemeProps() {
  return {
    classNamePrefix: REACT_SELECT_CLASS_PREFIX,
    styles: getReactSelectStyles(),
  };
}
